export default __webpack_public_path__ + "static/media/stripe-blurple.c4f72bcf.svg";